<div class="logo-holder">
  <img
    alt="B Research logo"
    [src]="(theme$ | async) === Theme.DARK ? darkLogoImg : lightLogoImg"
  />
</div>
